import { createAction, props } from '@ngrx/store';
import { User } from './Models/User';
import { UserCredentials } from './Models/UserCredentials';
import { RegisterFormModel } from './Models/RegisterFormModel';

export const login = createAction(
    '[Authentication] Login',
    props<UserCredentials>()
);

export const loginSuccess = createAction(
    '[Authentication] Login Success',
);

export const loginFailure = createAction(
    '[Authentication] Login Failure',
    props<{ error: string }>()
);

export const logout = createAction(
    '[Authentication] Logout'
);

export const register = createAction(
    '[Authentication] Register',
    props<RegisterFormModel>()
);
export const logoutSuccess = createAction(
    '[Authentication] Logout Success'
);

export const logoutFailure = createAction(
    '[Authentication] Logout Failure',
    props<{ error: string }>()
);

export const registerSuccess = createAction(
    '[Authentication] Register Success',
    props<{ user: User }>()
);

export const registerFailure = createAction(
    '[Authentication] Register Failure',
    props<{ error: string }>()
);